import { useState } from 'react'
import '../style.css'
import { Link } from 'react-router-dom'

export const Password = () => {
  const [pass, setPass] = useState('pass')
  return (
    <div className={pass}>
      <Link to="/ziano"> Indietro</Link>
      <input
        type="text"
        name=""
        id=""
        placeholder="Password"
        onChange={(e) => {
          if (e.target.value === 'Ziano2020') {
            setPass('hidden')
          }
        }}
      />
    </div>
  )
}
